import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const AWS = require("aws-sdk");

export default new Vuex.Store({
  state: {
    isAuthenticated: false,
    token: '',
    company: '',
    username: '',
    secret_name: "user/GadgetUserManagement",
    secrets_manager_user_access_key: "AKIAZTC32XW4VFHNQC6R",
    secrets_manager_user_secret_access_key: "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",
    access_key: "",
    secret_access_key: "",
  },
  mutations: {
    setAuth(state, token){
      state.isAuthenticated = true;
      state.token = token;
    },
    cleanAuth(state){
      state.isAuthenticated = false;
      state.token = '';
    },
    setCompany(state, company){
      state.company = company;
    },
    setUsername(state, user){
      state.username = user
    },
    initializeCredentials: async(state) => {
      // Use this code snippet in your app.
      // If you need more information about configurations or implementing the sample code, visit the AWS docs:
      // https://docs.aws.amazon.com/sdk-for-javascript/v3/developer-guide/getting-started.html

      const secretsManager = new AWS.SecretsManager({
        region: "eu-central-1",
        credentials : new AWS.Credentials({
          accessKeyId: state.secrets_manager_user_access_key,
          secretAccessKey: state.secrets_manager_user_secret_access_key
        })
      });

      
      /*const client = new SecretsManagerClient({
        region: "eu-central-1",
      });*/

      let response;

      try {
        const SecretId = state.secret_name;
        response = await secretsManager.getSecretValue({ SecretId }).promise();
        /*response = await client.send(
          new GetSecretValueCommand({
            SecretId: state.secret_name,
            VersionStage: "AWSCURRENT", // VersionStage defaults to AWSCURRENT if unspecified
          })
        );*/
        const { access_key, secret_access_key } = JSON.parse(response.SecretString);

        state.access_key = access_key;
        state.secret_access_key = secret_access_key

        state.credentialsSet = true;
        
      } catch (error) {
        // For a list of exceptions thrown, see
        // https://docs.aws.amazon.com/secretsmanager/latest/apireference/API_GetSecretValue.html
        throw error;
      }


    },
  },
  actions: {

  }
})
